import React from 'react';
import { SENSORS_DATA_TYPE } from '@/const';
import { cn } from '@/lib/utils';
import { useParams } from 'react-router-dom';
import { useNavigateEvidence } from '@/hooks/AssetsStudioPage/MainContent/VisualAI/useNavigateEvidence';
import { ASSET_STUDIO } from '@/types/shared/navigation-tabs.enums';
import { useNavigateOilReport } from '@/hooks/AssetsStudioPage/MainContent/SensorData/useNavigateOilReport';
import { Play, Droplet } from 'lucide-react';
import { ActionIcon } from '@/components/uiKit/ActionIcon';

interface AssetActionsBarProps {
  variant?: 'table' | 'normal' | 'component-card';
  className?: string;
  asset: any;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  actionIconVariant?: 'minimal' | 'badge';
  badgePosition?: 'top-right' | 'bottom-left';
}
//@TODO: make the components generic & reuseable
// asset can be  either component or asset

export const AssetActionsBar = ({ variant, asset, actionIconVariant = 'minimal', badgePosition = 'bottom-left' }: AssetActionsBarProps) => {
  const { diagnostics, asset_id, component_id, component_name, camera_components, oil_reported_components } = asset;
  const { id } = useParams();

  const hasCamera = !!camera_components?.length;
  const hasOilReport = !!oil_reported_components?.length;

  const firstCameraSensor = camera_components?.[0];

  const navigationData = {
    id: firstCameraSensor?.component_id || component_id,
    sourceType: SENSORS_DATA_TYPE?.Camera,
    //default date in case date is N/A
    diagnosticDate: diagnostics?.[0]?.diagnostic_created_at || '2024-08-04T00:00:00',
    assetId: asset_id || id,
    componentName: firstCameraSensor?.component_name || component_name,
  };
  const { navigateEvidence } = useNavigateEvidence(navigationData);

  // NOTE: Missing oil report diagnostics to complete - Senors data has to have component
  const { navigateOilReport } = useNavigateOilReport({
    assetId: asset_id || id,
    id: component_id,
  });

  const handleNavigate = (type: ASSET_STUDIO) => {
    switch (type) {
      case ASSET_STUDIO.VISUAL_AI:
        navigateEvidence();
        return;
      case ASSET_STUDIO.OIL_REPORT:
        navigateOilReport();
        return;
    }
  };

  return (
    <div className="flex items-center gap-1">
      {/* @TODO: change buttons to anchor for semantics */}
      {hasCamera && (
        <ActionIcon
          variant={actionIconVariant}
          badgePosition={badgePosition}
          icon={<Play className="text-foreground hover:text-primary-500 transition-colors" data-testid="camera_icon" />}
          onClick={() => handleNavigate(ASSET_STUDIO.VISUAL_AI)}
          tooltip="Visual AI"
        />
      )}
      {hasOilReport && (
        <ActionIcon
          variant={actionIconVariant}
          badgePosition={badgePosition}
          icon={<Droplet className="text-foreground hover:text-primary-500 transition-colors" data-testid="oil_icon" />}
          onClick={() => handleNavigate(ASSET_STUDIO.OIL_REPORT)}
          tooltip="Oil Report"
        />
      )}
      {/* {health_status_changed && variant === 'component-card' && (
        <BaseTooltip content={'Status Changed'}>
          <div className="pt-0.5">
            <Icon icon={CircleExclamationSolidFilledIcon} />
          </div>
        </BaseTooltip>
      )} */}
      {/* @TODO: replace false with real data once BE will support it */}
    </div>
  );
};
